export { default } from './DestacatBasic';
